/* two status cell editor mixin */
export default {
  props: {
    /**
     * 편집할 데이터 객체
     */
    data: {
      type: Object,
      required: true,
    },
    /**
     * 편집할 필드
     */
    property: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      /**
       * 편집할 값
       * @type {?}
       */
      value: null,
    };
  },
  watch: {
    data: {
      immediate: true,
      handler(to) {
        this.value = to[this.property];
      },
    },
  },
};



// WEBPACK FOOTER //
// ./src/components/table/cell-editor/mixins/two-status-cell-editor.js